module.exports = __webpack_public_path__ + "img/despertador.a3825480.png";